import { render, staticRenderFns } from "./BaseToggle.vue?vue&type=template&id=50ba6427"
import script from "./BaseToggle.vue?vue&type=script&lang=js"
export * from "./BaseToggle.vue?vue&type=script&lang=js"
import style0 from "./BaseToggle.vue?vue&type=style&index=0&id=50ba6427&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports